import { render, staticRenderFns } from "./ValorDelInventario.vue?vue&type=template&id=24885332&"
import script from "./ValorDelInventario.vue?vue&type=script&lang=js&"
export * from "./ValorDelInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports